import React from 'react';

const Section: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({ children, style }) => (
  <div style={{ background: '#f6f8fa', borderRadius: 12, padding: 20, marginBottom: 24, ...style }}>{children}</div>
);

export default Section; 